module.exports = __webpack_public_path__ + "img/arch2.4a5b957d.jpg";